import classNames from 'classnames/bind';
import { gql } from '@apollo/client';
import styles from './AcfCard.module.scss';
import { Image } from '@/components';
import BasicCard from './BasicCard/BasicCard';
import FlipCard from './FlipCard/FlipCard';

let cx = classNames.bind(styles);

export default function AcfCard(props) {
	const { card, attributes, innerBlocks } = props;
  const style = {};
	style['--minCardHeightMobile'] = card.minimumHeightMobile ? `${card.minimumHeightMobile}px` : '0px';
	style['--minCardHeightDesk'] = card.minimumHeightDesktop ? `${card.minimumHeightDesktop}px` : '0px';

	return card.flipCard ? <FlipCard cardAttr={card} attributes={attributes} innerBlocks={innerBlocks} style={style} /> : <BasicCard cardAttr={card} attributes={attributes} innerBlocks={innerBlocks} style={style} />;
}

AcfCard.fragments = {
	key: `AcfCardFragment`,
	entry: gql`
		${Image.fragments.entry}
		fragment AcfCardFragment on AcfCard {
			attributes {
        anchor
				className
        fullHeight
			}
			card {
				alignItemsDesktop
				alignItemsMobile
				backCta {
					target
					title
					url
				}
				backCtaStyle
				backText
				backgroundColor
				backgroundImage {
					...ImageFragment
				}
				backgroundImageSettings {
					objectFit
					objectPositionX
					objectPositionY
					hideOnDesktop
					hideOnMobile
				}
				flipCard
        hasBorder
				minimumHeightDesktop
        minimumHeightMobile
				mobileBackgroundImage {
					...ImageFragment
				}
				mobileBackgroundImageSettings {
					objectFit
					objectPositionY
					objectPositionX
				}
				reverseTextColor
			}
		}
	`,
};

AcfCard.config = {
	name: 'AcfCard',
};
AcfCard.displayName = 'AcfCard';
